/**
 * React Query Hooks for Backend Health Check
 *
 * Provides hooks for monitoring backend health status.
 */

import { useQuery } from '@tanstack/react-query';
import { healthAPI } from '../../services/tradingBotAPI';
import { queryKeys, staleTimeConfig } from '../../config/queryClient';

/**
 * Check backend health status
 *
 * @returns Query with backend health status
 */
export function useBackendHealth() {
  return useQuery({
    queryKey: queryKeys.health.backend(),
    queryFn: async () => {
      const response = await healthAPI.check();
      return response.data;
    },
    staleTime: staleTimeConfig.realtime, // 30 seconds
    retry: 1, // Only retry once for health checks
    refetchInterval: 60000, // Refetch every minute in background
  });
}
